import { http } from 'helpers/httpv2';

const URL_V2 = process.env.REACT_APP_API_V2;
const createDepartment = 'department/management/create';
const deleteDepartment = 'department/:id/delete';
const updateDepartemnet = 'department/:id/update';
const getDepartment = 'department/management/';
const addDepartmentMember = 'department/management/assignment/member';

export const apiPtAddDepartment = async (val) => {
  const datas = await http.post(`${URL_V2 + createDepartment}`, val);
  return datas.data.data;
};
export const apiPtDeleteDepartment = async (val) => {
  const datas = await http.get(`${URL_V2 + deleteDepartment}`);
  return datas.data.data;
};
export const apiPtUpdateDepartment = async (val) => {
  const datas = await http.put(`${URL_V2 + updateDepartemnet}`);
  return datas.data.data;
};
export const apiPtListDepartment = async ({ detail, id = 'list', board }) => {
  let url = `${URL_V2 + getDepartment}list?page=1&page_size=1000`;
  if (detail) {
    url = `${URL_V2 + getDepartment + id}`;
  } else if (board !== null && board !== undefined) {
    url = `${URL_V2 + getDepartment + board}`;
  }
  const datas = await http.get(`${url}`);
  return datas.data.data;
};
export const apiPtAddDepartmentMember = async (val) => {
  const datas = await http.post(`${URL_V2 + addDepartmentMember}`, val);
  return datas.data.data;
};
